import React, { FC, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { Button, SvgImage } from '../../../../../../shared/components';
import { useToggleFullscreen } from '../../hooks/use-toggle-fullscreen';
import { selectIsFullscreen } from '../../slice';
import styles from './styles.css';

type Props = {
    videoElementRef?: HTMLVideoElement | null;
};

export const FullscreenButton: FC<Props> = ({ videoElementRef }) => {
    const { toggleFullscreen } = useToggleFullscreen(videoElementRef);
    const isFullscreen = useSelector(selectIsFullscreen);
    const fullscreenButtonIcon = useMemo(() => {
        return <SvgImage imageName={isFullscreen ? 'fullscreenOut' : 'fullscreenIn'} />;
    }, [isFullscreen]);
    return (
        <Button
            view="neutral-transparent"
            size="sm"
            className={styles.fullscreenButton}
            onClick={toggleFullscreen}
            icon={fullscreenButtonIcon}
            pin="round-round"
        />
    );
};
